import { Box } from '@mui/material';
import { FC } from 'react';
import { ReferenceManyField, TextField } from 'react-admin';

import {
  GetB2bContractsDocumentsQuery,
  GetB2bContractsDocumentsResponseOne,
  getB2bContractsDocumentsSortColumns,
} from '@Common/types/bo/b2b/contracts/documents';

import { b2bContractsDocumentsTypesChoices } from '@sh4res/bo-common/choices/contracts';
import { DatagridTyped, EmptyScreen, Pagination } from '@sh4res/bo-common/components';
import { DocumentListViewerLink, SelectChipField, UTCDateField } from '@sh4res/bo-common/fields';
import { EmptyFolderSvg } from '@sh4res/bo-common/graphics';
import { ColumnList, RaSort } from '@sh4res/bo-common/utils';

const NoDocument = () => (
  <EmptyScreen label="resources.bo_common.b2b.contracts.documents.empty" svg={<EmptyFolderSvg />} />
);

const displayedColumns: (keyof GetB2bContractsDocumentsResponseOne)[] = [
  'id',
  'name',
  'type',
  'created_at',
];

const defaultSort: RaSort<GetB2bContractsDocumentsQuery> = { field: 'created_at', order: 'DESC' };

const columns: ColumnList<GetB2bContractsDocumentsResponseOne> = {
  id: (
    <TextField
      label="resources.bo_common.b2b.contracts.documents.labels.id"
      data-testid={'BoExternalContractsDocumentsList_IdColumn'}
    />
  ),
  contract_id: <TextField data-testid={'BoExternalContractsDocumentsList_ContractIdColumn'} />,
  name: (
    <DocumentListViewerLink<GetB2bContractsDocumentsResponseOne>
      urlSource="url"
      nameSource="name"
      label="resources.bo_common.b2b.contracts.documents.labels.url"
    />
  ),
  url: <TextField data-testid={'BoExternalContractsDocumentsList_UrlColumn'} />,
  type: (
    <SelectChipField
      choices={b2bContractsDocumentsTypesChoices}
      label="resources.bo_common.b2b.contracts.documents.labels.type"
      data-testid={'BoExternalContractsDocumentsList_TypeColumn'}
    />
  ),
  created_at: (
    <UTCDateField
      label="resources.bo_common.b2b.contracts.documents.labels.created_at"
      data-testid={'BoExternalContractsDocumentsList_CreatedAtColumn'}
    />
  ),
  updated_at: <UTCDateField data-testid={'BoExternalContractsDocumentsList_UpdatedAtColumn'} />,
};

export const ContractsDocumentsList: FC = () => (
  <ReferenceManyField
    label="resources.bo_common.b2b.contracts.documents.title"
    reference="contracts/documents"
    source="id"
    target="contract_id"
    sort={defaultSort}
    pagination={<Pagination limit={<></>} />}
    data-testid={'BoExternalContractsDocumentsList_DocumentsField'}>
    <Box sx={{ paddingTop: '3px', paddingBottom: '3px' }}>
      <DatagridTyped<GetB2bContractsDocumentsResponseOne>
        sortableColumns={getB2bContractsDocumentsSortColumns}
        columnRegistry={{
          ...columns,
        }}
        displayedColumns={[...displayedColumns]}
        bulkActionButtons={false}
        empty={<NoDocument />}
        showCard={true}
      />
    </Box>
  </ReferenceManyField>
);
